import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgInfo from '../../../../play-core/icons/Info';
import { Colors, hexToRGB } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../play-core/styles/z-index';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PersonalizesSectionInfo = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      icon: /*#__PURE__*/_jsx(SvgInfo, {}),
      color: Colors.GREY_d2d2d2
    }), /*#__PURE__*/_jsx("span", {
      children: t('global.personalizedSectionInfo')
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "PersonalizedSectionInfo__Layout",
  componentId: "sc-8ny7us-0"
})(["position:absolute;display:grid;grid-gap:8px;grid-auto-flow:column;align-items:center;z-index:", ";pointer-events:none;left:24px;right:24px;margin:0 auto 0 auto;top:34px;padding:9px 12px;min-width:0;max-width:max-content;color:", ";background-color:", ";", ";border-radius:4px;", "{top:60px;}", "{top:56px;}"], zIndex.calendar, Colors.WHITE, hexToRGB(Colors.CYAN_266f6e, 0.9), Fonts.medium(16), Viewports.for('large'), Viewports.for('xLargeUp'));